import {
  ChevronsLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsRightIcon,
} from 'lucide-react';

export const Pagination = ({ page, setPage, totalPages }) => {
  const handlePageChange = (newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="flex space-x-1 mt-8">
      <button
        className={`flex space-x-1 items-center text-xs text-[#313131] border rounded-[4px] border-[#E9E9E9] px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 ${page === 1 ? 'cursor-not-allowed bg-gray-100 focus:ring-0' : ''}`}
        aria-label="Go to first page"
        disabled={page === 1}
        onClick={() => handlePageChange(1)}
      >
        <ChevronsLeftIcon size={8} />
        <span>First</span>
      </button>

      {page > 1 && (
        <button
          className="flex space-x-1 items-center text-xs text-[#313131] border rounded-[4px] border-[#E9E9E9] px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500"
          aria-label="Go to previous page"
          disabled={page === 1}
          onClick={() => handlePageChange(page - 1)}
        >
          <ChevronLeftIcon size={8} />
          <span>Back</span>
        </button>
      )}

      <span
        className="flex space-x-1 items-center text-xs text-[#313131] border rounded-[4px] border-[#E9E9E9] px-2 py-1 bg-gray-200 font-semibold"
        aria-current="page"
      >
        {`${page} of ${totalPages}`}
      </span>

      {page < totalPages && (
        <button
          className="flex space-x-1 items-center text-xs text-[#313131] border rounded-[4px] border-[#E9E9E9] px-2 py-1  hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500"
          aria-label="Go to next page"
          onClick={() => handlePageChange(page + 1)}
        >
          <span>Next</span>
          <ChevronRightIcon size={8} />
        </button>
      )}

      <button
        className={`flex space-x-1 items-center text-xs text-[#313131] border rounded-[4px] border-[#E9E9E9] px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 ${page === totalPages ? 'cursor-not-allowed bg-gray-100 focus:ring-0' : ''} `}
        aria-label="Go to last page"
        disabled={page === totalPages}
        onClick={() => handlePageChange(totalPages)}
      >
        <span>Last</span>
        <ChevronsRightIcon size={8} />
      </button>
    </div>
  );
};
